export const ADVANCE_DECLINE_VIEW_ALL = "ADVANCE_DECLINE_VIEW_ALL";
export const ADVANCE_DECLINE_VIEW_ALL_STREAM = "ADVANCE_DECLINE_VIEW_ALL_STREAM";
export const ADVANCE_DECLINE_VIEW_ALL_QUOTE_STREAM = "ADVANCE_DECLINE_VIEW_ALL_QUOTE_STREAM";
export const ADVANCE_DECLINE_VIEW_ALL_ERROR = "ADVANCE_DECLINE_VIEW_ALL_ERROR";
export const ADVANCE_DECLINE_VIEW_ALL_HIDE_ERROR = "ADVANCE_DECLINE_VIEW_ALL_HIDE_ERROR";
export const ADVANCE_DECLINE_VIEW_ALL_START_LOADER = "ADVANCE_DECLINE_VIEW_ALL_START_LOADER";
export const ADVANCE_DECLINE_VIEW_ALL_STOP_LOADER = "ADVANCE_DECLINE_VIEW_ALL_STOP_LOADER";
